import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { configureActions } from '../../../../../actions/configure.action';
import { reportActions } from '../../../../../actions/report.actions';
import helper from '../../../../../utils/helper';
import NewMKTMonitorPage from './NewMKTMonitorPage';

class NewMKTMonitor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isSubmitting: false,
      sensors: [],
      errors: '',
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.sensors !== prevState.sensors) {
      state.sensors = nextProps.configure.sensors;
    }
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    if (nextProps.report.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.report.isSubmitting;
    }
    state.errors = helper.centralizeError([
      nextProps.configure.errors,
      nextProps.report.error,
    ]);
    return Object.keys(state).length ? state : null;
  }

  async componentDidMount() {
    const { departmentId } = this.props.match.params;
    await this.props.configureActions.getSensorsByDept(departmentId);
  }

  onCreateMKT = (values) => {
    const { departmentId } = this.props.match.params;
    this.props.reportActions
      .createMktMonitor({
        ...values,
        departmentId,
      })
      .then(() => this.props.history.push('/reports/mkt-monitors'))
      .catch((err) => console.log(err));
  };
  render() {
    const { loading, isSubmitting, sensors, errors } = this.state;
    return (
      <NewMKTMonitorPage
        sensors={sensors}
        isSubmitting={isSubmitting}
        errors={errors}
        onCreateMKT={this.onCreateMKT}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    report: state.report,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    reportActions: bindActionCreators(
      Object.assign({}, reportActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewMKTMonitor);
